import React, { useEffect } from 'react';

/**
 * Google AdSense component for displaying ads
 * @param {string} adSlot - The ad slot ID from Google AdSense dashboard
 * @param {string} adFormat - The ad format (default: 'auto')
 * @param {boolean} fullWidthResponsive - Whether the ad should be full width responsive
 * @param {object} style - Additional inline styles
 */
const AdSense = ({
  adSlot,
  adFormat = 'auto',
  fullWidthResponsive = true,
  style = {},
  className = ''
}) => {
  useEffect(() => {
    try {
      // Push ad to AdSense queue
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error('AdSense error:', e);
    }
  }, []);

  return (
    <div className={`ad-container ${className}`}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block', ...style }}
        data-ad-client="ca-pub-6121542796323824"
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
        data-full-width-responsive={fullWidthResponsive.toString()}
      />
    </div>
  );
};

export default AdSense;
